export const manifest = {
  screens: {
    scr_j70db0: { name: "Home", route: "/", position: {"x":0,"y":0}, isDefaultRow: true },
    scr_0bfazk: { name: "Whitehall product review", route: "/whitehall-product-test", position: {"x":160,"y":220} },
  },
  sections: {
    sec_tktdbf: { name: "Product Browsing Flow", x: 0, y: 0, width: 26720, height: 1180 },
    sec_iq8ptk: { name: "Company & Support", x: 0, y: 1980, width: 5720, height: 1180 },
    sec_nl42ts: { name: "Resources", x: 0, y: 3960, width: 5720, height: 1180 },
    sec_qrc26i: { name: "Showcases", x: 0, y: 5940, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_tktdbf", children: [
      { kind: "screen", id: "scr_0bfazk" },
    ] },
    { kind: "section", id: "sec_iq8ptk", children: [] },
    { kind: "section", id: "sec_nl42ts", children: [] },
    { kind: "section", id: "sec_qrc26i", children: [] },
    { kind: "screen", id: "scr_j70db0" },
  ],
}
